import { render, staticRenderFns } from "./skeletonMangadetail.vue?vue&type=template&id=53431825&scoped=true&lang=true&"
import script from "./skeletonMangadetail.vue?vue&type=script&lang=js&"
export * from "./skeletonMangadetail.vue?vue&type=script&lang=js&"
import style0 from "./skeletonMangadetail.vue?vue&type=style&index=0&id=53431825&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53431825",
  null
  
)

export default component.exports